export default __webpack_public_path__ + "static/media/logo.94117dd9.png";